import { POPOVER_COLLISION_PADDING } from "@/v2-ui/popover/popover.constants"
import { MULTI_SELECT_PREFERRED_HEIGHT } from "./multiSelect.constants"

export type MultiSelectResolvedSide = "top" | "bottom"

type ResolveMultiSelectOpenSideInput = {
  trigger: HTMLElement
  sideOffset: number
}

/**
 * Picks the side a `side="auto"` MultiSelect opens on. Called once per open
 * with a single rect read, so the choice is stable while the list resizes
 * (async suggestions, search filtering); Radix flip would re-run on every
 * content resize and hop between the sides.
 *
 * Bottom wins unless it offers less than the preferred height and the top
 * offers strictly more.
 */
export function resolveMultiSelectOpenSide(
  input: ResolveMultiSelectOpenSideInput,
): MultiSelectResolvedSide {
  const { trigger, sideOffset } = input
  // The popover is portaled to #mount with no collision boundary, so the
  // viewport is the box Radix measures available height against.
  const rect = trigger.getBoundingClientRect()
  const margin = sideOffset + POPOVER_COLLISION_PADDING
  const spaceBelow = window.innerHeight - rect.bottom - margin
  const spaceAbove = rect.top - margin
  const cramped = spaceBelow < MULTI_SELECT_PREFERRED_HEIGHT
  return cramped && spaceAbove > spaceBelow ? "top" : "bottom"
}
